import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FileTextIcon, SearchIcon, HandshakeIcon, PenToolIcon, BanknoteIcon, ArrowRightIcon } from 'lucide-react';
export function InteractiveTimeline() {
  const navigate = useNavigate();
  const steps = [{
    icon: FileTextIcon,
    title: 'Quick Application',
    desc: 'Complete our simple 2-minute application. No impact to your credit score.',
    detail: 'Average time: 2 minutes'
  }, {
    icon: SearchIcon,
    title: 'Instant Analysis',
    desc: 'We analyze your business needs and our AI matches you with the best options.',
    detail: '200+ lending partners'
  }, {
    icon: HandshakeIcon,
    title: 'Get Matched',
    desc: 'Receive multiple funding offers tailored to you. Compare rates and terms.',
    detail: 'Multiple offers in 24h'
  }, {
    icon: PenToolIcon,
    title: 'Choose & Submit',
    desc: 'Select your preferred offer and submit required documents with our help.',
    detail: 'Dedicated support'
  }, {
    icon: BanknoteIcon,
    title: 'Receive Funding',
    desc: 'Get approved and receive funds in as little as 48 hours via direct deposit.',
    detail: 'Avg: 2-3 business days'
  }];
  return <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-385">
      <div className="max-w-7xl mx-auto" data-id="element-386">
        <div className="text-center mb-16" data-id="element-387">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-388">
            How It Works
          </h2>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-389">
            Our streamlined process makes securing business funding simple and
            stress-free.
          </p>
        </div>

        <div className="relative" data-id="element-390">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-zinc-900 -z-10" data-id="element-391">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} className="h-full bg-white" data-id="element-392" />
          </div>

          <div className="grid md:grid-cols-5 gap-8" data-id="element-393">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.2,
            duration: 0.5
          }} className="relative flex flex-col items-center text-center group" data-id="element-394">
                <div className="w-24 h-24 bg-black rounded-full border-4 border-zinc-800 flex items-center justify-center mb-6 shadow-lg group-hover:border-white transition-all duration-300 relative z-10" data-id="element-395">
                  <step.icon className="w-10 h-10 text-white transition-transform" data-id="element-396" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full text-black font-bold flex items-center justify-center text-sm border border-black" data-id="element-397">
                    {index + 1}
                  </div>
                </div>

                <h3 className="text-lg font-bold text-white mb-2" data-id="element-398">
                  {step.title}
                </h3>
                <p className="text-sm text-zinc-400 mb-4" data-id="element-399">{step.desc}</p>

                <div className="opacity-0 group-hover:opacity-100 transition-opacity absolute -bottom-8 bg-zinc-900 text-white text-xs py-1 px-3 rounded-full whitespace-nowrap font-medium border border-zinc-800" data-id="element-400">
                  {step.detail}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-401">
          <button onClick={() => navigate('/application')} className="bg-white text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-200 transition-colors shadow-lg inline-flex items-center gap-2 group" data-id="element-402">
            Start Your Application Now
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-403" />
          </button>
        </div>
      </div>
    </section>;
}